var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.414 18.333c-7.82.011-13.756-5.995-13.747-13.747 0-.507.41-.92.916-.92h2.42c.454 0 .84.334.907.784.16 1.077.473 2.125.93 3.113l.095.203a.65.65 0 0 1-.211.8c-.75.535-1.036 1.612-.452 2.453a10.8 10.8 0 0 0 2.71 2.71c.84.583 1.917.297 2.452-.452a.65.65 0 0 1 .8-.212l.203.094c.988.458 2.036.771 3.113.931.45.067.783.453.783.907v2.42a.92.92 0 0 1-.917.916z"
  })));
};
export default SvgPhone;